import React from 'react'

import { TTextProps, Text } from 'elements/text/Text'
import { Chip, TChipProps } from 'elements/ui/Chip'

import { ICON } from 'config/icons'

import { COMMUNITY_ROLE } from 'modules/community/constants'
import { getUserRole } from 'modules/community/functions'
import type { TCommunity } from 'modules/community/types'

const roles = {
  [COMMUNITY_ROLE.MEMBER]: {
    icon: ICON.CHECK,
    text: 'trans:community:community.role.member.member',
    longText: 'trans:community:community.role.member.long',
  },
  [COMMUNITY_ROLE.ANIMATOR]: {
    icon: ICON.WRITER,
    text: 'trans:community:community.role.animator.word',
    longText: 'trans:community:community.role.animator.long',
  },
  [COMMUNITY_ROLE.ADMINISTRATOR]: {
    icon: ICON.ROLE,
    text: 'trans:community:community.role.administrator.word',
    longText: 'trans:community:community.role.administrator.long',
  },
  [COMMUNITY_ROLE.CREATOR]: {
    icon: ICON.ROLE,
    text: 'trans:community:community.role.creator.word',
    longText: 'trans:community:community.role.creator.long',
  },
} as const

export type TCommunityRoleBadgeProps = {
  community: TCommunity
  longText?: boolean
} & TTextProps &
  TChipProps

export const CommunityRoleBadge: TFCC<TCommunityRoleBadgeProps> = ({ community, longText, ...otherProps }) => {
  let role = COMMUNITY_ROLE.MEMBER
  const { isAdmin, isAnimator, isCreator, isMember } = getUserRole(community)
  if (isAdmin) {
    role = COMMUNITY_ROLE.ADMINISTRATOR
  } else if (isAnimator) {
    role = COMMUNITY_ROLE.ANIMATOR
  } else if (isCreator) {
    role = COMMUNITY_ROLE.CREATOR
  }

  return isMember ? (
    longText ? (
      <Text color="green" {...otherProps}>
        {roles[role].longText}
      </Text>
    ) : (
      <Chip icon={roles[role].icon} color="black30" {...otherProps}>
        {roles[role].text}
      </Chip>
    )
  ) : null
}
